import { Component, computed, inject, Input, signal } from '@angular/core';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { BuildingEquipmentService, BuildingEquipmentStatisticItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { currentTenant } from '@/utils/admin-utils';
import { loader } from '@/utils/signals/loader';

@Component({
  standalone: false,
  selector: 'wr-tga-statistic-dialog',
  templateUrl: './tga-statistic-dialog.component.html',
  styleUrl: './tga-statistic-dialog.component.scss'
})
export class TgaStatisticDialogComponent {
  private readonly buildingEquipmentService = inject(BuildingEquipmentService);
  private readonly router = inject(Router);
  private readonly dialogRef = inject(NbDialogRef);

  @Input()
  title!: string;
  @Input()
  equipmentId!: string;
  @Input()
  externalTenantId!: string;

  currentTenant = currentTenant();

  searchText = signal<string>('');

  readonly loading = loader();

  buildingEquipments = asyncComputed(() => {
    return  this.buildingEquipmentService.getBuildingEquipmentStatisticItem(
      this.externalTenantId,
      this.equipmentId
    );
  },undefined, this.loading);

  filteredBuildingEquipments = computed(() => {
    const searchText = this.searchText().toLowerCase();
    const buildingEquipments = this.buildingEquipments() ?? [];

    if (!searchText) return buildingEquipments;

    return buildingEquipments.filter(buildingEquipment =>
      buildingEquipment.buildingName?.toLowerCase().includes(searchText)
    );
  });

  searchTextChange($event: any) {
    this.searchText.set($event);
  }

  getIcon(statisticItem: BuildingEquipmentStatisticItemDto): string {
    return statisticItem.icon?.presignedUrl ?? '';
  }

  navigateToBuildingEquipments(event: Event, equipmentId: string, buildingId: string): void {
    event.stopPropagation();
    this.dialogRef.close();
    if (this.currentTenant()?.type === 'Internal') {
      this.router.navigate(['/buildingEquipments'], { queryParams: { equipmentId: equipmentId,
        externalTenantId: this.externalTenantId, buildingId: buildingId } });
    }
    else if (this.currentTenant()?.type === 'External') {
      this.router.navigate(['/external/buildingEquipments'], { queryParams: {
        equipmentId: equipmentId, buildingId: buildingId
      } });
    }
  }
}
